// extracted by mini-css-extract-plugin
export var headline = "contactMain-module--headline--1bI7K";
export var title = "contactMain-module--title--zl1eO";
export var text = "contactMain-module--text--brIHM";
export var map = "contactMain-module--map--vdM71";